import React from 'react';
import {useWindowSize} from "../../../hooks";
import {Container} from "react-bootstrap";

export function ABCardShop({className, styleWidth = "20rem", children}) {
    const {width} = useWindowSize()
    const useBorder = width <= 576 ? "w-100 " : "border rounded shadow-sm"
    const styleW = width <= 576 ? "" : styleWidth

    return <div className={`d-flex bg-light-subtle p-3 mb-2 ${useBorder} ${className}`} style={{width: styleW}}>{children}</div> // bg-light-subtle
}

export function ABContainer({children}) {
    const {width} = useWindowSize()
    if (width < 576)
        return children
    else
        return <Container fluid="lg">{children}</Container>

}

export function ABCardShopBottom({className, styleWidth = "20rem", children}) {
    const {width} = useWindowSize()
    const useBorder = width <= 576 ? "w-100 " : "border rounded shadow-sm"
    const styleW = width <= 576 ? "" : styleWidth

    return <div className={`d-flex bg-light-subtle p-3 mb-2 ${useBorder} ${className}`} style={{width: styleW}}>{children}</div> // bg-light-subtle
}